import React, { Component } from 'react'
import { toast } from 'react-toastify'

import { Get } from 'utils/axios-template'

const StyleSheetHOC = ( WrappedComponent ) => {
  class StylesheetWrappedComponent extends Component {
    state = {
      loading: false,
      stylesheets: []
    }

    load = param => this.setState({ loading: param })
    requestSuccess = success => toast.success( success, {
      position: "top-right",
      autoClose: 5000,
      hideProgressBar: false,
      closeOnClick: true,
      pauseOnHover: true,
      draggable: false
    })
    requestError = error => toast.error( error, {
      position: "top-right",
      autoClose: 5000,
      hideProgressBar: false,
      closeOnClick: true,
      pauseOnHover: true,
      draggable: false
    })

    getStylesheets = ( site_id ) => Get(
      `/sites/${ site_id }/stylesheets`,
      this.getStylesheetsSuccess,
      this.getStylesheetsError,
      this.load
    )
    getStylesheetsSuccess = payload => this.setState({ stylesheets: payload })
    getStylesheetsError = error => this.requestError( error )

    render = () => {
      return (
        <>
          <WrappedComponent
            { ...this.props }
            getStylesheets={ this.getStylesheets }
            onLoadStylesheet={ this.state.loading }
            stylesheets={ this.state.stylesheets } />
        </>
      )
    }
  }
  return StylesheetWrappedComponent
}

export default StyleSheetHOC